module.exports = __webpack_public_path__ + "static/media/Bell429.e2b6a8d3.png";